/* eslint-disable max-classes-per-file */
import { defaults as _defaults } from 'lodash';
const defaultDataInterchangeConfig = {
    Name: '',
    Actions: [
        {
            type: 'getfile',
            Attributes: {
                type: 'getfile'
            },
            NestedNodes: [
                {
                    Name: 'source',
                    Attributes: {
                        file: '',
                        host: '',
                        path: ''
                    }
                }
            ]
        },
        {
            type: 'importrecords',
            Attributes: {
                table: '',
                key: '',
                delimiter: ',',
                header: false,
                deactivateabsent: false,
                sendsummaryto: '',
                fieldsinquotes: 'true',
                log: 'true',
                commitchanges: false,
                welcomeemail: false,
                type: 'importrecords'
            },
            NestedNodes: []
        },
        {
            type: 'archivefile',
            Attributes: {
                type: 'archivefile'
            },
            NestedNodes: []
        }
    ]
};
class DataInterchangeConfig {
    Name;
    Actions;
    constructor(params) {
        _defaults(this, params, defaultDataInterchangeConfig);
    }
}
const defaultDITypeConfig = {
    getfile: {
        Type: ''
    },
    mappingAction: {
        Type: '',
        TargetValues: []
    }
};
class DITypeConfig {
    getfile;
    mappingAction;
    constructor(params) {
        _defaults(this, params, defaultDITypeConfig);
    }
}
export { DataInterchangeConfig, DITypeConfig };
